export const UK_TRADE_MARK_NUMBER = 'UK00004396824';
export const REGISTERED_TRADE_MARK_NOTICE =
  `Know Your Care® is a registered trade mark. UK Trade Mark No. ${UK_TRADE_MARK_NUMBER}.`;

export function ProductBrand() {
  return (
    <>
      Know Your Care
      <sup aria-hidden="true" className="registered-mark">®</sup>
    </>
  );
}

export default function StudioBrand() {
  return <><ProductBrand /> Studio</>;
}

export function TrademarkNotice() {
  return <span>{REGISTERED_TRADE_MARK_NOTICE}</span>;
}

export function SidebarTrademarkNotice() {
  return <span>Know Your Care® is a registered trade mark.</span>;
}
